/**
 * Angular imports
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports
 */
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConnectionCardModule } from '../../connection/connection-card/connection-card.module';
import { InfoModalModule } from '../../common/info-modal/info-modal.module';
import { ConnectionSuggFilterModule } from '../connection-sugg-filter/connection-sugg-filter.module';

/**
 * Component imports
 */
import { ConnectionRequestListComponent } from './connection-request-list.component';



@NgModule({
  declarations: [
    ConnectionRequestListComponent
  ],
  imports: [
    CommonModule,
    InfoModalModule,
    ConnectionCardModule,
    ConnectionSuggFilterModule,
    InfiniteScrollModule
  ],
  exports: [
    ConnectionRequestListComponent
  ]
})
export class ConnectionRequestListModule { }
